export default __webpack_public_path__ + "static/media/Success.dd96f623.png";